import { BaseTool } from '../BaseTool';

export class StartingViewTool extends BaseTool {
    id = 'MANAGE_STARTING_VIEW';
    name = 'Starting View';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openManageDialog('startingView');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
